import { capitalize, pluralize } from "../helpers/index.js";
import { getContainerTypes } from "../productCommons/index.js";

export const generateFulfillmentTypeContainerDeliveryChargeName = ({
  volume,
  packQuantity,
  displayUnit,
  containerType,
}: {
  volume: number;
  packQuantity: number;
  displayUnit: string;
  containerType: string;
}) => {
  return `${packQuantity}x${volume}${displayUnit} ${pluralize(
    capitalize(containerType),
    packQuantity,
  )} `;
};

export const findProductFulfillmentTypeDeliveryCharge = ({
  fulfillmentTypeContainerDeliveryCharges,
  product,
}: {
  fulfillmentTypeContainerDeliveryCharges?: {
    volume: number;
    packQuantity: number;
    displayUnit: string;
    containerType: string;
    charge: number;
  }[];
  product: {
    volume: number | null;
    packQuantity: number | null;
    displayUnit: string | null;
    containerType: string | null;
  };
}) => {
  return fulfillmentTypeContainerDeliveryCharges?.find(
    (item) =>
      getContainerTypes(product.containerType).includes(item.containerType) &&
      // @ts-expect-error
      (item.displayUnit === product.displayUnit ?? "") &&
      item.packQuantity === product.packQuantity &&
      item.volume === product.volume,
  );
};
